import { useProfileContext } from "../contexts/ProfileContext";
import { isOrderabilityGuardActiveFor } from "../utils/functions/orderabilityScope";

// REACT_APP_DESIGN_ORDERABILITY_GUARD_ORG_IDS (19/10): the viewer-aware
// answer to "is the order guard's UI active" - the global flag, or the
// viewer's organisation / its parent in the org-id list (a customer under a
// listed dealer). ProfileContext already holds both (organizationId = the
// impersonated dealer under act-as, as useProfile is keyed on it;
// organization.parentId = a customer's dealer), so 0 calls of its own.
// Flag off + empty list = false everywhere = today's UI.
export function useOrderabilityGuardActive(): boolean {
  const { organizationId, organization } = useProfileContext();
  return isOrderabilityGuardActiveFor(organizationId, organization?.parentId);
}
